import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_ALLERGEN_SIMPLE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateAllergenSimpleDetailsArgs } from '../graphql/transformers'
import { UPDATE_ALLERGEN_SIMPLE_DETAILS } from '../redux/action-types'

const useUpdateAllergenSimpleDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isSimpleDetailsLoading, simpleDetailsError } = useSelector(
    store => store.allergens.allergen,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_ALLERGEN_SIMPLE_DETAILS_MUTATION,
        { id, data: transformToUpdateAllergenSimpleDetailsArgs(data) },
        dispatch,
        UPDATE_ALLERGEN_SIMPLE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isSimpleDetailsLoading, error: simpleDetailsError },
  ]
}

export default useUpdateAllergenSimpleDetailsMutation
